var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcPaymentReversal = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  viewBox: "0 0 34 34",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 34,
  fill: "none"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 17.5,
  cy: 19.5,
  r: 8.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.2 16 a2.9 2.9 0 0 0 -2.7 -1.5 c-1.6 0 -2.9 0.95 -2.9 2.1 s1.3 2.1 2.9 2.1 s2.9 0.95 2.9 2.1 s-1.3 2.1 -2.9 2.1 a2.9 2.9 0 0 1 -2.7 -1.5"
}), /*#__PURE__*/React.createElement("line", {
  x1: 17.5,
  y1: 12.8,
  x2: 17.5,
  y2: 26.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.5 10.5 A13 13 0 0 1 17.5 3 a12.9 12.9 0 0 1 8 2.8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.6 5.2 V11.2 H10.6"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcPaymentReversal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_payment_reversal.2391ede36e58c8c9fb8bfa627bbecd6b.svg";